@defer (prefetch on immediate) {
    <cc-navigation-bar
        *ngIf="isLobbyLoaded && extendMenuDslEvalCompleted"
        [lobbyType]="lobbyType"
        [categoryRoute]="categoryRoute"
        [lobbyProduct]="lobbyProduct"
        [productOverride]="productOverride"
        [stickyInputQueryElement]="stickyInputQueryElement"></cc-navigation-bar>
}
